
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/dashboard",
      function () {
        return require("private-next-pages/products/dashboard.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/dashboard"])
      });
    }
  